import { render, staticRenderFns } from "./ModalEditEstablishmentContact.vue?vue&type=template&id=3a962855&scoped=true"
import script from "./ModalEditEstablishmentContact.vue?vue&type=script&lang=js"
export * from "./ModalEditEstablishmentContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a962855",
  null
  
)

export default component.exports